import { DeleteSecretInput42tzeavgre6q as DeleteSecretInput } from './schema/type/DeleteSecretInput.mjs';
import { DeleteSecretMutation2wndasm4ltzuw as DeleteSecretMutation } from './schema/DeleteSecretMutation.mjs';
import { voidResult3hb4jxf0f2mcw as voidResult } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/VoidResult.mjs';
import { Unauthorized_instancena1wy93qjp67 as Unauthorized_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatcher3r3trxa1ofgr6 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/DeleteSecretCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toInput($this, $receiver) {
  return new (DeleteSecretInput())($receiver.q2l_1, $receiver.r2l_1);
}
function *perform(command, $completion) {
  var tmp0_safe_receiver = (yield* this.r6t(new (DeleteSecretMutation())(toInput(this, command)), $completion)).b42_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b6f_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : voidResult(tmp1_safe_receiver);
  return tmp2_elvis_lhs == null ? Unauthorized_instance : tmp2_elvis_lhs;
}
var SdkDeleteSecretCommandDispatcherClass;
function SdkDeleteSecretCommandDispatcher() {
  if (SdkDeleteSecretCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkDeleteSecretCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkDeleteSecretCommandDispatcherClass = $;
  }
  return SdkDeleteSecretCommandDispatcherClass;
}
//region block: exports
export {
  SdkDeleteSecretCommandDispatcher as SdkDeleteSecretCommandDispatcher1wzqb0vkuors,
  perform as perform3fglo63zx58sn,
};
//endregion

//# sourceMappingURL=SdkDeleteSecretCommandDispatcher.mjs.map
